export default "/images/1.svg?c52d3cc057c0efbc82bc0e6afe291c47";